import React, { useEffect } from "react";
import { CSVLink } from "react-csv";
import moment from "moment";
import { qualifications } from "util/UniversitiesList";

function ExportCsv({ data, filename }) {
  // const { data, filename } = props;
  useEffect(() => {
    console.log(data);
  }, []);
  const headers = [
    { label: "Full Name", key: "name" },
    // {label: "Father's Name", key: "guardian"},
    { label: "Date of Birth", key: "dob" },
    { label: "Email Address", key: "email" },
    { label: "Mobile Number", key: "phone" },
    { label: "Alternate Mobile Number", key: "altPhone" },
    // {label: "Current Address", key: "address"},
    { label: "Current City of Residence", key: "city" },
    // {label: "Home Town", key: "hometown"},
    { label: "CNIC", key: "cnic" },
    { label: "Gender", key: "gender" },
    { label: "Nationality", key: "nationality" },

    { label: "Latest Degree", key: "degree" },
    { label: "University Name", key: "institute" },
    { label: "CGPA", key: "cgpa" },
    { label: "Specialization", key: "specialization" },
    { label: "Graduating Year", key: "graduationYear" },
    { label: "Resume", key: "resume" },
    {
      label: "HomeTown",
      key: "homeTown",
    },
    {
      label: "Qualifications",
      key: "qualification",
    },
    {
      label: "CreatedAt",
      key: "createdAt",
    },

    // {label: "In case of any other degree, please specify details", key: "otherDegreeDetails"},
    //
    // {
    //     label: "Mention Details of any Internships (Company Name, Department and Year of Internship)",
    //     key: "internshipDetails"
    // },
    // {label: "Experience (years)", key: "yearExp"},
    // {label: "Company Name", key: "companyName"},
    // {label: "Designation", key: "designation"},
    // {label: "Department", key: "department"},
    // {
    //     label: "In case you are currently working somewhere, please specify the total tenure that you have been with your current employer",
    //     key: "currentJobDetails"
    // },
    //
    // {
    //     label: "Do you have any relatives working within CCI Pakistan or or having Business Relations with CCI or Competition in the capacity of permanent, company contract, third party contractors employees, customers or suppliers, owners, directors, shareholders of vendors, distributors or CCI business partners?",
    //     key: "anyRelativesAtCCI"
    // },
    // {label: "If Yes, please specify the Name and Designation of your relative", key: "cciRelativesDetails"},
    // {label: "If Yes, please specify your Relationship with him/her", key: "cciRelativeRelation"},
    // {label: "Interviewed Before by CCI Pakistan?", key: "interviewedBefore"},
    // {label: "If Yes, please specify the position and year", key: "currentJobTenure"},
    //
    // {label: "Do you have a valid driving license", key: "haveDrivingLicense"},
    // {
    //     label: "What are your career aspirations and How will this Talent Program add value to reach the desired goal",
    //     key: "goalInLife"
    // },
    // {label: "Tell us about your personality in 3 words", key: "aboutYourPersonality"},
    // {label: "How you heard about CCI hiring (Default)", key: "howYouFoundUsSelect"},
    // {label: "How you heard about CCI hiring (Other)", key: "howYouFoundUs"},
  ];

  const csvReport = {
    data: data.map((object) => {
      const dobTimestamp = object.dob;
      const dobDate =
        dobTimestamp && dobTimestamp.seconds ? dobTimestamp.toDate() : null; // Convert Firestore Timestamp to JavaScript Date
      const formattedDob = dobDate ? moment(dobDate).format("DD/MMM/YYYY") : ""; // Format date, or set to empty string if dobDate is null
      const date = moment(object.createdAt * 1000);

      return {
        ...object,
        dob: formattedDob,
        createdAt: date.format("DD/MMM/YYYY"),
      };
    }),
    headers: headers,
    filename: filename,
  };

  return (
    <div>
      <CSVLink
        className="btn btn-primary form-control"
        {...csvReport}
        filename="User CSV"
      >
        Export CSV
      </CSVLink>
    </div>
  );
}

export default ExportCsv;
